import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Link } from "react-router"
import { LogoIcon } from "./LogoIcon"

interface LogoProps {
  path?: string
  linkTitle?: string
}

export const Logo: React.FC<LogoProps> = ({ path, linkTitle }) => {
  const { translate } = useTranslation()
  if (path !== undefined) {
    return (
      <Link to={path} title={linkTitle} aria-label={translate("LOGO_ALT")}>
        <LogoIcon className="text-yellow1 transition-colors hover:text-yellow1" />
      </Link>
    )
  }

  return <LogoIcon className="text-yellow1" aria-hidden />
}
